import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { VirtualFormModel, VirtualSearchPayload } from '@/types/virtual-search';

import { formatAggregationFilters } from '@/helpers/virtual-search';
import { useVirtualSearch } from '@/composables/virtual-search';
import AirMasterService from '@/services/air-imports/master.service';
import { AirFilterDefaultForm } from '@/constants/air/master-awb/mawb-table';
import { AirMblEntity } from '@/types/air/mbl/air-mbl.entity';

export const useVirtualAirMblStore = defineStore('Virtual-MAWB', () => {
  const filterForm = ref<VirtualFormModel>(AirFilterDefaultForm());
  const options = computed<VirtualSearchPayload<AirMblEntity>>(() => ({
    chunkSize: 15,
    ...formatAggregationFilters(filterForm.value),
  }));
  const { items, aggregations, isFetching, fetchedAllItems, search, total } = useVirtualSearch(
    AirMasterService.virtualSearch,
    options
  );

  const resetFilters = async () => {
    filterForm.value = AirFilterDefaultForm();
  };

  return {
    options,
    filterForm,
    items,
    aggregations,
    isFetching,
    total,
    fetchedAllItems,
    search,
    resetFilters,
  };
});
